import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { Form, Button, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const Rating = ({ roomTypeId, userId }) => {
  const { t, i18n } = useTranslation();
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [hover, setHover] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {}, [i18n.language, t]);

  const submitRating = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_APP_URL}/rating/send`,
        { room_type_id: roomTypeId, rating, review },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${token}`,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        }
      );

      Swal.fire({
        title: "Success!",
        text: "Rating submitted successfully!",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
        width: "auto",
      });

      setRating(0);
      setReview("");

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to submit rating.",
          icon: "error",
          confirmButtonColor: "#d33",
          width: "auto",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container p-4 border rounded shadow-sm bg-light position-relative">
      <h4 className="mb-3 text-center">
        {i18n.language === "ID" ? "Beri Penilaian" : t("giveARating")}
      </h4>

      {loading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <Spinner animation="border" variant="light" />
            <p>Submitting your rating...</p>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-center mb-3">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          return (
            <FaStar
              key={index}
              className="star mx-1"
              color={starValue <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
              size={40}
              onClick={() => setRating(starValue)}
              onMouseEnter={() => setHover(starValue)}
              onMouseLeave={() => setHover(null)}
              style={{
                cursor: "pointer",
                border: "2px solid #bdbdbd",
                borderRadius: "5px",
                padding: "5px",
              }}
            />
          );
        })}
      </div>

      <Form>
        <Form.Group className="mb-3">
          <Form.Label>
            {" "}
            {i18n.language === "ID" ? "Buat Ulasan" : t("writeAReview")}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder={
              i18n.language === "ID"
                ? "Ceritakan Pengalaman Anda"
                : t("writeYourExperience")
            }
            value={review}
            onChange={(e) => setReview(e.target.value)}
            className="shadow-sm"
          />
        </Form.Group>

        <Button
          variant="success"
          className="w-100"
          onClick={submitRating}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Rating"}
        </Button>
      </Form>
    </div>
  );
};

export default Rating;
